import { render } from "./MenuLateralComponent.vue?vue&type=template&id=6df036ec"
import script from "./MenuLateralComponent.vue?vue&type=script&lang=js"
export * from "./MenuLateralComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__